import React, { useState } from "react";
import "./Sidebar.css";
import { SidebarData } from "../../Data/data";
import { UilBars } from "@iconscout/react-unicons";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import Button from "@mui/material/Button";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Logo from "../../assets/coppel.svg";
import SmallLogo from "../../assets/coppelIcon.svg";

const Sidebar = (props) => {
  const { logout, showTitles } = props;
  const [selected, setSelected] = useState();
  const [expanded, setExpanded] = useState(true);

  const sidebarVariants = {
    true: {
      left: "0",
    },
    false: {
      left: "-60%",
    },
  };
  return (
    <>
      <div
        className="bars"
        style={expanded ? { left: "50%" } : { left: "5%" }}
        onClick={() => setExpanded(!expanded)}
      >
        <UilBars />
      </div>
      <motion.div
        className="main-sidebar"
        variants={sidebarVariants}
        animate={window.innerWidth <= 720 ? `${expanded}` : ""}
      >
        {/* logo */}
        <div className="logoNav">
          <img src={Logo} alt="logo" style={{ opacity: showTitles ? 1 : 0 }} />
          <img
            src={SmallLogo}
            alt="logo"
            style={{ opacity: showTitles ? 0 : 1 }}
          />
        </div>

        <div className="menu">
          {SidebarData.map((item, index) => {
            return (
              <NavLink
                to={`${item.route}`}
                className={selected === index ? "menuItem active" : "menuItem"}
                key={index}
                onClick={() => {
                  setSelected(index);
                  setExpanded(!expanded);
                }}
              >
                {typeof item.icon === "string" ? (
                  selected === index ? (
                    <img
                      src={item.icon}
                      alt={item.heading}
                      height={28}
                      width={28}
                    />
                  ) : (
                    <img
                      src={item.iconAlt}
                      alt={item.heading}
                      height={28}
                      width={28}
                    />
                  )
                ) : (
                  <item.icon />
                )}
                {showTitles ? <span>{item.heading}</span> : ""}
              </NavLink>
            );
          })}
          <Button
            onClick={logout}
            variant="text"
            sx={{
              position: "absolute",
              bottom: "0",
              paddingBottom: "40px",
              paddingLeft: showTitles ? "30px" : "0",
              color: "#ffffff",
              fontDecoration: "none",
              textTransform: "none",
              textAlign: "center",
            }}
            endIcon={<ExitToAppIcon />}
          >
            {showTitles ? (
              <h3 className="hidden xl:block">Cerrar sesión</h3>
            ) : (
              ""
            )}
          </Button>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
